import styled, { css } from 'styled-components';

import { h2 } from 'styles/fonts';

export const MainContainer = styled.div`
  width: 100%;
  display: flex;
  flex-direction: column;
  gap: ${({ theme }) => theme.padding.small};
`;

export const Container = styled.div`
  width: 100%;
  display: flex;
  flex-direction: column;
  overflow-x: scroll;
  position: relative;

  ::-webkit-scrollbar {
    display: none;
  }
  -ms-overflow-style: none; /* IE and Edge */
  scrollbar-width: none; /* Firefox */
`;

export const TabsList = styled.div`
  display: flex;
  flex-direction: row;
`;

export const TabButton = styled.button`
  height: 48px;
  padding: 0 20px;
  border: none;

  display: flex;
  flex-shrink: 0;
  align-items: center;
  justify-content: center;

  ${h2};
  cursor: pointer;
  background-color: transparent;

  ${({ theme }) => css`
    color: ${theme.colors.white.main};
    &:hover {
      color: ${theme.colors.white.hover};
    }
    &:active {
      color: ${theme.colors.white.hover};
    }
  `}
`;

export const BorderLine = styled.div`
  height: 2px;

  left: 0;
  bottom: 0;
  position: absolute;
  transition: left 0.3s;

  border-radius: 2px 2px 0px 0px;
  background-color: ${({ theme }) => theme.colors.white.main};
`;

export const Tab = styled.div`
  width: 100%;
  display: flex;
`;
